module.exports = __webpack_public_path__ + "static/media/phone.8eae45ef.png";